import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { SuspenseHidden } from "@/uiKit/atoms/SuspenseHidden.tsx";
import { SuspenseWithError } from "@/uiKit/atoms/SuspenseWithError.tsx";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";

export type BasePageProps = PropsWithChildren<{
  floatingAction?: React.ReactNode;
}>;

export type PageProps = AtomProps<BasePageProps, StyleClasses<"root">>;

export const Page: React.FC<PageProps> = ({ id, className, classes, children, floatingAction, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <div id={id} className={cx(styles.root, className)} {...props}>
      <SuspenseWithError pendingFallback={CenteredLoader} errorFallback={HandledErrorCard}>
        {children}
      </SuspenseWithError>
      <SuspenseHidden>{floatingAction}</SuspenseHidden>
    </div>
  );
};

const makeStyles = () => ({
  root: css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "clip",
  }),
});
